import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Removes the default SEO tags injected by /public/index.html
 * (meta[name="description"][data-default] and link[rel="canonical"][data-default])
 * so React Helmet (or useCitySeo) is the single source of truth.
 *
 * Runs on every route change. Skips legacy/blocked routes where the static
 * fallback canonical/title set by index.html must remain.
 */
const LEGACY_PATTERNS = [
  /^\/wp-admin(?:\/|$)/,
  /^\/wp-login\.php$/,
  /^\/wp-json(?:\/|$)/,
  /^\/xmlrpc\.php$/,
  /^\/\.env$/,
  /^\/\.git(?:\/|$)/,
  /^\/vendor(?:\/|$)/,
  /^\/wp-content(?:\/|$)/,
];

export default function DefaultSeoCleanup() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if (LEGACY_PATTERNS.some((re) => re.test(pathname))) return;
    document
      .querySelectorAll('[data-default="true"]')
      .forEach((el) => el.remove());
  }, [pathname]);

  return null;
}
